import React from "react";
import {
  Scan2,
  ScanBaladna,
  ScanGift,
  ScanLww,
  ScanSpinWin,
} from "../../assets/images";
import styled from "styled-components";
import SpinWheel from "../SpinWheel";

const SpinWheelElements = ({
  onResultSelected,
  onRotate,
  rotate,
  segments,
  selected,
  segmentColors,
}) => {
  return (
    <MainContainer>
      <ScanSpinImages>
        <ScanSpinParksTop>
          <ScanSpinImage src={ScanSpinWin} />
        </ScanSpinParksTop>
        <ScanSpinParksBottom>
          <ScanParkLogo src={ScanLww} />
          <ScanParkLogo src={ScanBaladna} />
        </ScanSpinParksBottom>
      </ScanSpinImages>
      <SpinWheelWrapper>
        <SpinWheelContainer>
          <SpinWheel
            size={"18rem"}
            segments={segments}
            selectedSeg={selected.name}
            rotate={rotate}
            onResultSelected={onResultSelected}
            onRotate={onRotate}
            segmentColors={segmentColors}
          />
          <SpinWheelFooter>
            <SpinWheelGift src={ScanGift} />
            <LicenseText>
              {/* LICENSE: {process.env.REACT_APP_SPIN_WHEEL_LICENSE} */}
            </LicenseText>
            <InfoText>
              <img src={require("../../assets/images/scan-text.png")} />
            </InfoText>
          </SpinWheelFooter>
        </SpinWheelContainer>
      </SpinWheelWrapper>
    </MainContainer>
  );
};

const InfoText = styled.div`
  color: white;
  text-align: center;
  z-index: 1;
  width: 100%;
  > img {
    width: 100%;
  }
`;

const LicenseText = styled.div`
  color: white;
  text-align: center;
  padding: 0 1rem;
  font-size: 0.6rem;
  z-index: 1;
  opacity: 0.3;
`;

const ScanSpinImages = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 25%;
  position: relative;
`;

const ScanSpinParksTop = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
`;
const ScanSpinParksBottom = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  position: absolute;
  height: 5rem;
  width: 100%;
  bottom: -2rem;
`;
const ScanSpinImage = styled.img`
  width: 17rem;
`;
const ScanParkLogo = styled.img`
  width: 6rem;
  height: 6rem;
`;

const SpinWheelWrapper = styled.div`
  height: 55%;
  display: flex;
  align-items: flex-start;
`;
const SpinWheelContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

const SpinWheelFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: absolute;
  bottom: -7rem;
  width: 100%;
`;

const SpinWheelGift = styled.img`
  width: 80%;
`;

const MainContainer = styled.div`
  height: 100vh;
  background-image: url(${Scan2});
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-position: center top;
  // padding: 2rem 0;
  box-sizing: border-box;
`;

export default SpinWheelElements;
